export default [
  {
    date: 1445438181081,
    row: 17,
    col: 13,
    squares: [
      [2, 7, "#FFFF00"],
      [3, 7, "#FFFF00"],
      [4, 7, "#FFFF00"],
      [3, 6, "#FFFF00"],
      [3, 8, "#FFFF00"],
      [5, 7, "#008000"],
      [6, 6, "#008000"],
      [6, 7, "#008000"],
      [6, 8, "#008000"],
      [7, 5, "#008000"],
      [7, 6, "#FF0000"],
      [7, 7, "#008000"],
      [7, 8, "#008000"],
      [7, 9, "#008000"],
      [8, 6, "#008000"],
      [8, 7, "#FF0000"],
      [8, 8, "#008000"],
      [9, 5, "#008000"],
      [9, 6, "#008000"],
      [9, 7, "#008000"],
      [9, 8, "#FF0000"],
      [9, 9, "#008000"],
      [10, 4, "#008000"],
      [10, 5, "#0000FF"],
      [10, 6, "#008000"],
      [10, 7, "#008000"],
      [10, 8, "#008000"],
      [10, 9, "#FF0000"],
      [10, 10, "#008000"],
      [11, 5, "#008000"],
      [11, 6, "#0000FF"],
      [11, 7, "#008000"],
      [11, 8, "#008000"],
      [11, 9, "#008000"],
      [12, 4, "#008000"],
      [12, 5, "#008000"],
      [12, 6, "#008000"],
      [12, 7, "#0000FF"],
      [12, 8, "#008000"],
      [12, 9, "#008000"],
      [12, 10, "#008000"],
      [13, 3, "#008000"],
      [13, 4, "#FEC3AC"],
      [13, 5, "#008000"],
      [13, 6, "#008000"],
      [13, 7, "#008000"],
      [13, 8, "#0000FF"],
      [13, 9, "#008000"],
      [13, 10, "#008000"],
      [13, 11, "#008000"],
      [14, 7, "#800000"],
      [15, 7, "#800000"],
      [16, 7, "#800000"],
      [1, 1, "#808080"],
      [1, 2, "#000000"],
      [1, 3, "#808080"],
      [1, 4, "#000000"],
      [1, 6, "#000000"],
      [1, 5, "#808080"],
      [1, 7, "#808080"],
      [1, 8, "#000000"],
      [1, 9, "#808080"],
      [1, 10, "#000000"],
      [1, 11, "#808080"],
      [1, 12, "#000000"],
      [1, 13, "#808080"],
      [2, 13, "#000000"],
      [3, 13, "#808080"],
      [4, 13, "#000000"],
      [5, 13, "#808080"],
      [6, 13, "#000000"],
      [7, 13, "#808080"],
      [8, 13, "#000000"],
      [9, 13, "#808080"],
      [10, 13, "#000000"],
      [11, 13, "#808080"],
      [12, 13, "#000000"],
      [13, 13, "#808080"],
      [14, 13, "#000000"],
      [2, 1, "#000000"],
      [3, 1, "#808080"],
      [4, 1, "#000000"],
      [5, 1, "#808080"],
      [6, 1, "#000000"],
      [7, 1, "#808080"],
      [8, 1, "#000000"],
      [9, 1, "#808080"],
      [10, 1, "#000000"],
      [11, 1, "#808080"],
      [12, 1, "#000000"],
      [13, 1, "#808080"],
      [14, 1, "#000000"],
      [15, 1, "#808080"],
      [16, 1, "#000000"],
      [17, 1, "#808080"],
      [17, 2, "#000000"],
      [17, 3, "#808080"],
      [17, 4, "#000000"],
      [17, 5, "#808080"],
      [17, 6, "#000000"],
      [17, 7, "#808080"],
      [17, 8, "#000000"],
      [17, 9, "#808080"],
      [17, 10, "#000000"],
      [17, 11, "#808080"],
      [17, 12, "#000000"],
      [17, 13, "#808080"],
      [16, 13, "#000000"],
      [15, 13, "#808080"],
    ],
  },
];
